var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TemplateEmailsManagement',{ref:"page",attrs:{"title":'{{name}}',"subtitle":_vm.$t(_vm.emailTitle),"translations":_vm.brandEmailsTranslations,"avaibleLocales":_vm.avaibleLocales,"defaultLocale":_vm.defaultLocale,"error-msg":_vm.$t('client.emails.error'),"publish-route":_vm.$listRoutes.websiteEditEmailsPublish}})
}
var staticRenderFns = []

export { render, staticRenderFns }